"use strict";

var Backbone = require("backbone");
var _ = require("underscore");
var $ = require("jquery");
Backbone.$ = $;

var debug = require("debug")("views:BlocksView");
var template = require("../templates/blocks-template.html");

/**
 * BlocksView: display all text blocks from semantic model
 * Trigger
 * - "click:block"
 * - "change:mode"
 * - "article:open"
 */
module.exports = Backbone.View.extend({

    model: null, // Retronews PageSemanticModel
    pageModel: null,
    documentModel: null,
    template: _.template(template), // compile template
    className: "blocks-view",
    mode: "page", // page ou article
    articleId: null, // article initialement affiché

    events: {
        "click p": "onClick",
        "click h2": "onClick",
        "click .block-footer": "onToggleMode",
        "click .block-article h2": "onClickArticle"
    },

    initialize: function (options) {
        var T = this;
        _.extend(T, options);
        T.listenTo(T.model, "sync", T.render);
        T.listenTo(T.pageModel, "sync", T.render);
        T.render();
    },

    hasMainArticles: function () {
        var T = this;
        var articles = T.model.get("articles");
        var is_main_article;
        _.every(articles, function (article) {
            if (_.has(article, "main_article")) {
                is_main_article = article.main_article;
            }
            else {
                is_main_article = article.blocks.length > 2 ? true : false;
            }
            return !is_main_article;
        });
        return is_main_article;
    },

    render: function () {
        var T = this,
            context = {},
            str_html_blocks = "";

        if (T.model.fetched && T.pageModel.fetched) {
            debug("render");

            if (T.app.bot && T.pageModel.get("readability") < 0.8) {
                // on affiche pas le texte pour les bot si la readability est mauvaise
                return;
            }
            context.mode = T.mode;
            context.page = T.pageModel.get("label");
            context.nbPages = T.documentModel.get("nbPages");
            context.hasMainArticles = T.hasMainArticles();

            var blocks = T.model.get("blocks");

            if (T.mode == "page") {
                //search medium font size = font the most used in document
                if (blocks) {
                    var medium_font_size = 10;
                    var max_words_title = 20;
                    var all_font_sizes = 0;
                    var nb_words = 0;
                    _.each(blocks, function (block) {
                        all_font_sizes += block.font_size * block.word_count;
                        nb_words += block.word_count;
                    });

                    if (nb_words) {
                        medium_font_size = Math.round((all_font_sizes / nb_words) * 1.1);
                    }

                    _.each(blocks, function (block) {
                        var tag = block.font_size > medium_font_size && block.word_count < max_words_title ? "<h2>" : "<p>";
                        var $el = $(tag, {
                            id: block.id
                        });
                        // on fait cette manip pour éliminer le html que l'ocr aurait pu produire par hasard
                        $el.text(block.text);
                        str_html_blocks += $el[0].outerHTML;
                    });
                }

            }
            else {
                //affichage des artiles
                if (context.hasMainArticles) {
                    var articles = T.model.get("articles");
                    _.each(articles, function (article) {
                        // on affiche seulement les articles principaux
                        // si syllabs a rempli le flag main_article on l'utilise, sinon on compte le nombre de blocks (doit être supérieur à 2)
                        var is_main_article;
                        if (_.has(article, "main_article")) {
                            is_main_article = article.main_article;
                        }
                        else {
                            is_main_article = article.blocks.length > 2 ? true : false;
                        }
                        if (!is_main_article) return;
                        str_html_blocks += '<div class="block-article" id="' + article.id + '">';
                        // titre de l'article
                        var $el = $("<h2>");
                        var title = article.title;
                        if (!title || title.length === 0) {
                            // si pas de titre on prends les premiers mots du premier block
                            var first_block = T.model.block(article.blocks[0].blockid);
                            if (first_block) {
                                title = first_block.text.substr(0, 50);
                                title += "...";
                            }
                        }
                        $el.text(title);
                        str_html_blocks += $el[0].outerHTML;

                        //texte de l'article
                        _.each(article.blocks, function (block) {
                            $el = $("<p>", {
                                id: block.blockid
                            });
                            var block_model = T.model.block(block.blockid);
                            if (block_model) {
                                if (block_model.text == article.title) {
                                    $el.addClass("hidden-title"); // pour éviter la répétition du titre dans le texte
                                }
                                $el.text(block_model.text);
                                str_html_blocks += $el[0].outerHTML;

                            }
                        });

                        str_html_blocks += "</div>";
                    });
                }
                else {
                    str_html_blocks = "<p class='no-main-articles'>" + STR.no_main_articles + "</p>";
                }
            }

            context.blocks = str_html_blocks;
            T.$el.html(T.template(context));

            if (T.articleId) {
                T.gotoArticle(T.articleId);
                T.articleId = null; // pour ne plus faire de highlight au prochain affichage
            }
        }
    },

    gotoBlock: function (block_id) {
        var T = this,
            $body = T.$(".block-body"),
            $block = T.$("#" + block_id);
        if ($block.length) {
            if (T.mode == "article") {
                if (!$block.parent().hasClass("open")) {
                    $block.parent().addClass("open");
                    this.trigger("article:open", this, $block.parent().attr("id"), true);
                }
                if ($block.hasClass("hidden-title")) {
                    // on cache des données dans les styles ... pas terrible mais pas le temps de faire mieux
                    $block = $block.parent();
                }
            }
            $body.animate({
                scrollTop: $body.scrollTop() + $block.position().top
            },
                500
            );
        }
    },

    gotoArticle: function (article_id) {
        var T = this,
            $article = T.$("#" + article_id),
            $body = T.$(".block-body");

        if ($article.length) {
            // open article
            $article.addClass("open");
            this.trigger("article:open", this, article_id, true);

            // scroll to
            $body.animate({
                scrollTop: $body.scrollTop() + $article.position().top
            },
                500
            );

            // highlight article
            T.highlightArticle(article_id);
        }
    },

    highlightArticle: function (article_id) {
        var T = this,
            article = T.model.article(article_id);// recherche des blocs qui composent cet article
        if (article) {
            var block_ids = [];
            _.each(article.blocks, function (block) {
                block_ids.push(block.blockid);
            });
            this.trigger("click:block", this, block_ids);
        }
    },

    onToggleMode: function () {
        var T = this;
        T.mode = T.mode == "page" ? "article" : "page";
        T.render();
        this.trigger("change:mode", T, T.mode);
    },

    onClick: function (e) {
        if (e.target.id) {
            this.trigger("click:block", this, [e.target.id]);
        }
    },

    onClickArticle: function (e) {
        var T = this;
        // ouvre ou ferme l'article si on appuie sur le titre
        var $article = $(e.target).parent();
        $article.toggleClass("open");

        var article_id = $article.prop("id");
        if ($article.hasClass("open")) {
            T.highlightArticle(article_id);
            this.trigger("article:open", this, article_id, true);
        }
        else {
            this.trigger("article:open", this, article_id, false);
        }

    },

    close: function () {
        var T = this;
        T.model = null;
        T.pageModel = null;
        T.documentModel = null;
        T.stopListening();
        T.undelegateEvents();
    }
});
